import {createSlice} from "@reduxjs/toolkit";

const documentClaimSlice= createSlice({
    name: "documentClaimSlice",
    initialState:{
        screenShotsTop:[[],[],],
        screenShotsBottom:[[],[],],
        uploadedFiles:[],
        interMediateFormData:[],
        formScreenshot:"",
        calledFrom:"",
        pkey:"",

    },
    reducers: {
        addScreenshotsTop(state,action){
            return{
                ...state,
                screenShotsTop:action.payload,
            }
        },

        resetScreenshotsTop(state,action){
            state.screenShotsTop=[[],[],];
        },

        resetScreenshotsBottom(state,action){
            state.screenShotsBottom=[[],[],];
        },

        addScreenshotsBottom(state,action){
            state.screenShotsBottom=action.payload;
        },


        addUploadedFiles(state,action){
            state.uploadedFiles=action.payload;
        },

        addIntermediateFormData(state,action){
        },
        
        setFormScreenshot(state,action){
            state.formScreenshot=action.payload;
        },

        setCalledFrom(state,action){
            state.calledFrom=action.payload;
        },

        setpKey(state,action){
            state.pkey=action.payload;
        }  
    },
});

export default documentClaimSlice.reducer;
export const { addScreenshotsTop, addScreenshotsBottom,resetScreenshotsBottom,resetScreenshotsTop,addUploadedFiles,addIntermediateFormData,setFormScreenshot,setCalledFrom,setpKey } = documentClaimSlice.actions;